import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    // You can customize your typography here if needed
    // For example, adjusting font family, font sizes, etc.
  },
  palette: {
    primary: {
      light: "#7880ff",
      main: "#2c53ff",
      dark: "#002aca",
      contrastText: "#fff",
    },
  },
});

export default theme;
